import React from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Row from 'react-bootstrap/Row';

const CourseDetails = props => {
  const id = props.match.params.id;
  return (
    <Jumbotron style={{ marginTop: 69 }}>
      <Container>
        <Row className='custom-vertical-align'>
          <Col xs={12} md={6} className='text-center'>
            <h1>CRM - Crew Resource Management{id}</h1>
            <p className='mt-3'>
              Capacitación para la correcta gestión de recursos de la cabina de mando y de la compañía.
            </p>
          </Col>
          <Col xs={12} md={6}>
            <Button variant='primary' size='lg' className='ml-5'>
              Incribirme
            </Button>
          </Col>
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default CourseDetails;
